<template>
  <div class="asc-airline-mgmt-wrapper">
    <asc-page-header class="asc-airline-mgmt-header">
      <template slot="pageTitle"
        ><asc-surface-title title="AIRLINE ONBOARDING MANAGEMENT"
      /></template>
      <template slot="pageActions"
        ><asc-accent-button
          class="asc-airline-mgmt-header--button"
          button-text="Add Airline"
          :on-click="addAirline"
          :disabled="disabled"
        ></asc-accent-button
      ></template>
    </asc-page-header>
    <asc-airline-mgmt-grid
      :values="values"
      :add-airline="addAirline"
      :disabled="disabled"
      :on-open="onOpenAirline"
    ></asc-airline-mgmt-grid>
  </div>
</template>

<script>
import AscAirlineMgmtGrid from '@/components/molecules/AscAirlineMgmtGrid.vue'
import AscSurfaceTitle from '@/components/atoms/AscSurfaceTitle'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscAccentButton from '@/components/atoms/AscAccentButton'

export default {
  name: 'AscAirlineMgmtWrapper',

  components: {
    AscAirlineMgmtGrid,
    AscSurfaceTitle,
    AscPageHeader,
    AscAccentButton,
  },

  props: {
    values: {
      type: Array,
      default: () => [],
    },
    addAirline: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onOpenAirline: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss">
.asc-airline-mgmt-wrapper {
  padding: 16px;
  overflow-y: scroll;
}

.asc-airline-mgmt-header {
  background-color: $primary-white;

  &--button {
    display: flex;
    justify-content: flex-end;
    padding-right: 10px;
  }
}
</style>
